import {environment as defaultEnvironment} from './environment';

export const environmentLoader = new Promise<any>((resolve) => {

  const xmlhttp = new XMLHttpRequest();
  xmlhttp.open('GET', './assets/json/environment.json', true);
  xmlhttp.onload = function() {

    let env = defaultEnvironment;

    if (xmlhttp.status === 200 ) {
      if (xmlhttp.responseText !== undefined && xmlhttp.responseText.length > 0) {
        env = Object.assign(env, JSON.parse(xmlhttp.responseText));
      }
    }

    resolve(env);
  };

  xmlhttp.send();

});
